import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    CircularProgress,
    TableContainer
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import TablePager from '../../components/atom/TablePager';
import ActionIconButton from '../../components/atom/ActionIconButton';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';
import SortableTableCell from '../../components/atom/SortableTableCell';
import { useSorting } from '../../hooks/useSorting';
import { UserIcon } from '../../icons';
import AdminHeader from '../../components/atom/AdminHeader';

function NegativeBalancesPage() {
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const { sort, sortDir, setSorting } = useSorting(['balance', 'ASC']);

    const [data, loading, error] = useSwaggerClient('users', 'getNegativeBalances', {
        page,
        pageSize,
        sort,
        sortDir
    });

    useEffect(() => {
        if (loading) {
            return;
        }

        if (data?.users.length === 0 && page !== 0) {
            setPage(0);
        }
    }, [page, data, loading, setPage]);

    return (
        <Grid container className="bg-white client-table page" alignItems="center" spacing={2}>
            <AdminHeader title="Users with Negative Balance" />
            <Grid item container xs={12} justifyContent="center">
                {loading && (!data || data?.users.length === 0) ? (
                    <CircularProgress />
                ) : (
                    <>
                        <TableContainer style={{ overflowX: 'auto' }}>
                            <Table
                                className="mt-2"
                                style={{ backgroundColor: 'white' }}
                                size="small"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>User ID</TableCell>
                                        <SortableTableCell
                                            arrow={sort === 'name' ? sortDir : ''}
                                            onClick={() => setSorting('name')}
                                        >
                                            Name
                                        </SortableTableCell>
                                        <TableCell>Email</TableCell>
                                        <SortableTableCell
                                            arrow={sort === 'balance' ? sortDir : ''}
                                            onClick={() => setSorting('balance')}
                                        >
                                            Balance
                                        </SortableTableCell>
                                        <TableCell>Payment Method</TableCell>
                                        <SortableTableCell
                                            arrow={sort === 'last_refund' ? sortDir : ''}
                                            onClick={() => setSorting('last_refund')}
                                        >
                                            Last Refund Date
                                        </SortableTableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {error && (
                                        <TableRow>
                                            <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                                                <Alert severity="error">
                                                    <h4>
                                                        {error.response?.body?.message ||
                                                            error.message}
                                                    </h4>
                                                </Alert>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {data &&
                                        data.users &&
                                        data.users.map(user => (
                                            <TableRow key={`${user.userId}-${user.slug}`}>
                                                <TableCell>{user.userId}</TableCell>
                                                <TableCell>{user.name}</TableCell>
                                                <TableCell>{user.email}</TableCell>
                                                <TableCell
                                                    style={{
                                                        color: '#d32f2f',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    ${user.balance}
                                                </TableCell>
                                                <TableCell>{user.paymentMethod}</TableCell>
                                                <TableCell>
                                                    {user.lastRefundDate
                                                        ? moment
                                                              .utc(user.lastRefundDate)
                                                              .format('MM/DD/YYYY, h:mm a')
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    <ActionIconButton
                                                        title="View Guest"
                                                        icon={UserIcon}
                                                        to={`/guests/${user.userId}`}
                                                        target="_blank"
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    {data && data.users && data.users.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                                                No users with negative balance found.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid container justifyContent="flex-end">
                            <TablePager
                                total={data?.total}
                                page={page}
                                setPage={setPage}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                            />
                        </Grid>
                    </>
                )}
            </Grid>
        </Grid>
    );
}

export default NegativeBalancesPage;
